<template>
	<div class="template text" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<div v-show="dataVal.datas.length > 0">
				<div v-for="(data,i) in dataVal.datas" :key="i">
					<h3 id="duo-xuan-kuang-zu">{{i + 1}}.{{data.Question}}</h3>
					<el-checkbox-group v-model="data.checkList">
					    <p v-for="(option,index) in data.Options" :key="index" class="answer">{{option}} <br/></p>
					    <el-checkbox v-for="(item,inx) in data.Options" :key="inx + 'index' " :label="ListOptions[inx]"></el-checkbox>
					 </el-checkbox-group>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui'
	export default {
		props: ['dataVal'],
		data() {
			return {
				ListOptions: ['A','B','C','D','E']
			}
		},
		mounted() {

		},
		methods: {
			getGuidGenerator() { 
			    var S4 = function() { 
			       return (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
			    }; 
			    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4()); 
			}
		}
	}
</script>

<style scoped="scoped">
	@import '../assets/css/common.css';

	.input_value {
		width: calc(100% - 124px);
	}
	.answer{
	    font-size: 14px;
	    color: #5e6d82;
	    line-height: 1.5em;
		margin-top: 5px;
		margin-bottom: 5px;
	}
</style>
